import { colors } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import Table, { TableProps } from "@mui/material/Table";

export type StyledTableProps = {
  striped?: boolean | "odd" | "even";
  noBottomBorder?: boolean;
} & TableProps;

const StyledTable = styled(Table, {
  shouldForwardProp: (prop) => !["striped", "noBottomBorder"].includes(prop as string),
})<StyledTableProps>(({ striped, noBottomBorder, theme }) => ({
  "& .MuiTableRow-root": {
    ...((striped === true || striped === "odd") && {
      ":nth-of-type(odd):not(.MuiTableRow-head)": {
        backgroundColor: colors.grey[100],
      },
    }),
    ...(striped === "even" && {
      ":nth-of-type(even):not(.MuiTableRow-head)": {
        backgroundColor: colors.grey[100],
      },
    }),
    ...(noBottomBorder && {
      "&:last-of-type:not(.MuiTableRow-head) .MuiTableCell-root": {
        borderBottom: 0,
      },
    }),
    "&.MuiTableRow-hover:hover": {
      cursor: "pointer",
      backgroundColor: alpha(theme.palette.primary.light, 0.2),
    },
  },
  "& .MuiTableCell-head": {
    fontWeight: "bold",
  },
}));

export default StyledTable;
